import React, {Component} from "react";
import Icons from "../../icon";
import { ConfirmationNotificationModal } from "../modal/confirmation-modal.component";
import { Button } from "react-bootstrap";
import moment from 'moment';
import { CONFIRMATION_VALUE } from "../../../utils/constant.utils";
import { httpDownload, httpGet, httpPost } from '../../../utils/api.utils';
import { ORDER_AUDIT_VERBIAGE, FILE_ATTACHMENT_MODULES, DISPLAY_ITEM } from "../../../constants/external-constants";
import Translation from "../translation/translation.component";
import { convertToFormatDate, displayFinalFileName } from "../../../utils/helpers.utils";

class CommentList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            commentID: 0,
            expanded: false,
            showModal: false,
            extractAlertMsg: "",
            showNumberOfComments: DISPLAY_ITEM.five
        }
    
    }

    componentDidMount() {
        this.setState({ isLoading: false });
    }

    handleViewMore = async () => {
        if (this.state.isLoading) return;

        this.setState({ isLoading: true });

        try {
            await this.props.handleLoadMore();
        } finally {
            this.setState({ isLoading: false });
        }
    };
    
    handleViewLess() {
        this.setState({ expanded: false })
    }

    handleDelete(commentID) {
        this.setState({
            commentID : commentID,
            showModal: true,
            modalMessage: "Are you sure you want to delete?"
        });
        
    }

    handleModal(okCancel) {
        this.setState({           
            showModal: false,
        });
        if(CONFIRMATION_VALUE.Ok === okCancel) {
            this.props.deleteCommentAction(this.state.commentID);            
        }
      
    }

    displayComment = (data) => {
        var yearDayMonth = (data.State === false && data.ModifiedDate) ? convertToFormatDate(data.ModifiedDate, "MMMM DD, YYYY") : "";
        var modifiedDate = (data.State === false && data.ModifiedDate) ? convertToFormatDate(data.ModifiedDate, "hh:mm A") : "";
        return data.State === false ? ORDER_AUDIT_VERBIAGE.deleteCommentOrder.replace("{yearDayMonth}", yearDayMonth).replace("{time}", modifiedDate) : data.Comment;
    }   

    downloadFile = async (circuitEquipmentDisputeInvoiceID, commentID, fileName, fromRequestData) => {
        var fileAttachementModule =
            this.props.isEquipment ? FILE_ATTACHMENT_MODULES.equipmentComments 
                : this.props.isDisputeComment ? FILE_ATTACHMENT_MODULES.disputeComments 
                : this.props.isInvoiceComment ? FILE_ATTACHMENT_MODULES.invoiceComments
                : this.props.isManageUserComment ? FILE_ATTACHMENT_MODULES.manageUserComments
                : this.props.isOrderDetailsComment ? FILE_ATTACHMENT_MODULES.orderDetailsComments
                : this.props.isQuotationDetailsComment ? FILE_ATTACHMENT_MODULES.quotationDetailsComments
                : this.props.isPlanCatalogueComment? FILE_ATTACHMENT_MODULES.planCatalogueComments
                : this.props.isBillingComment? FILE_ATTACHMENT_MODULES.billingComments
                : this.props.isContractComment ? FILE_ATTACHMENT_MODULES.contractComments
                : this.props.isRechargeInventoryComment? FILE_ATTACHMENT_MODULES.rechargeComments
                : this.props.isOutputComment? FILE_ATTACHMENT_MODULES.outputComments
                : this.props.isLocationComment ? FILE_ATTACHMENT_MODULES.locationComments
                : FILE_ATTACHMENT_MODULES.circuitComments;
        if (fromRequestData && this.props.isOrderDetailsComment) {
            if (window.confirm(this.state.extractAlertMsg)) {
                await httpDownload('common/fileAttachment/downloadFile/'
                    + FILE_ATTACHMENT_MODULES.orderCreation + '/'
                    + circuitEquipmentDisputeInvoiceID + '/'
                    + encodeURIComponent(fileName))
                    .then(function (response) {
                        return response.blob();
                    })
                    .then(function (blob) {
                        let downloadUrl = window.URL.createObjectURL(blob);
                        //Hide Loading
                        let a = document.createElement('a');
                        if (window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(blob, fileName);
                        } else if (typeof a.download === 'undefined') {
                            window.location = downloadUrl;
                        } else {
                            a.href = downloadUrl;
                            a.download = fileName
                            document.body.appendChild(a);
                            a.click();
                        }
                    });
            }
        }
        else {
            if (window.confirm(this.state.extractAlertMsg)) {
                await httpDownload('common/fileAttachment/downloadFile/'
                    + fileAttachementModule + '/'
                    + circuitEquipmentDisputeInvoiceID + '/'
                    + commentID + '/'
                    + encodeURIComponent(fileName))
                    .then(function (response) {
                        return response.blob();
                    })
                    .then(function (blob) {
                        let downloadUrl = window.URL.createObjectURL(blob);
                        //Hide Loading
                        let a = document.createElement('a');
                        if (window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(blob, fileName);
                        } else if (typeof a.download === 'undefined') {
                            window.location = downloadUrl;
                        } else {
                            a.href = downloadUrl;
                            a.download = fileName
                            document.body.appendChild(a);
                            a.click();
                        }
                    });
            }

        }
       
    };
        
    getFileNames = (data) => {
        const fileName = data["FileName"];
        if (!fileName) return [];
        if (Array.isArray(fileName)) return fileName;
        if (data["Comment"] === 'Request logged.') return fileName.split(':').filter(Boolean);
        try {
            const parsed = JSON.parse(fileName);
            return Array.isArray(parsed) ? parsed : [String(parsed)];
        } catch {
            return [fileName];
        }
    }

    onChangeExtractAlertMsg = (val, key) => {
        this.setState({
            extractAlertMsg: val
        });
    }

    render() {
        const { commentList } = this.props;
        var showNumberOfComments = this.state.showNumberOfComments < commentList?.length ? this.state.showNumberOfComments : commentList?.length;
        return (

            <div className="history-wrapper">
                <Translation
                    getOnlyText={true}
                    onChangeTranslation={this.onChangeExtractAlertMsg}
                    translationKey={"export_alert_message"} />
                <div className="data-container">
                    {(this.props.commentList && this.props.commentList.length > 0 ) ?
                        commentList?.map((data, index) =>                    
                            <div key={index} className="history-container">
                                <div className="file-with-icon-container">
                                    {
                                        (data["State"] || data["Comment"] === 'Request logged.') &&
                                        this.getFileNames(data).map((file, i) => (
                                            <div key={i}
                                                className={`${!this.props.isReadOnly ? "pointer" : "nopointer"} file-item`}
                                                onClick={(this.props.isReadAndExtractOnly || this.props.isReadAndWrite) ?
                                                    () => {
                                                        const id = data["FinanceContractID"] || data["FinanceAccountID"] || data["PlanID"] || data["CircuitID"] || data["DisputeID"] || data["InvoiceID"] || data["OrderID"] || data["QuotedRequestId"] || data["EmployeeID"] || data["EquipmentID"] || data["RechargingInventoryID"] || data["RechargingOutputConfigurationId"]
                                                                   || data["LocationID"];
                                                        if (id != null) {
                                                            this.downloadFile(id, data["CommentID"], file, data["Comment"] === 'Request logged.' ? true : false );
                                                        }
                                                    } : () => { }}
                                            >
                                                <Icons
                                                    customClassName="icon-file-clip"
                                                    name="paper-clip-solid"
                                                    size="14px"
                                                    containerClass="icon-paper-clip-file-container"
                                                />
                                                {data["State"]}
                                                {displayFinalFileName(file)}
                                            </div>
                                        ))}
                                    {
                                        (data["State"] && this.props.isReadAndWrite) && (data["isOwnerComment"] || data["IsOwnerComment"])&&
                                        <Icons
                                            customClassName="icon-trash"
                                            name="trash-can"
                                            size="14px"
                                            containerClass="icon-trash-container"
                                            onClick={() => this.handleDelete(data["CommentID"])}
                                        />
                                    }

                                </div>
                                <div className="vertical-blue-line">
                                </div>
                                <div className="comment-detail-container">
                                    <div className="history-detail-header">
                                        <span className="history-name-label"> {data["FirstName"]} {data["LastName"]} </span>
                                        <p> posted on</p>
                                        <span className="history-date-label">{moment.utc(data["DateCreated"]).format("MMMM DD, yyyy")}</span>
                                        <p> at</p>
                                        <span className="history-date-time">{moment.utc(data["DateCreated"]).format('hh:mm A')} </span>
                                    </div>
                                    <p>
                                        {this.displayComment(data)}
                                    </p>
                                </div>
                            </div>
                        )
                        :
                        <div className="no-message-container">
                            <h1>{this.props.noMessage}</h1>
                        </div>
                    }
                </div>
                <ConfirmationNotificationModal 
                    show={this.state.showModal} 
                    customClass="comment-notification-modal modal-text-bold"
                    title={'Delete'} 
                    handleModal={this.handleModal.bind(this)} 
                    message={this.state.modalMessage} />              
                {this.props?.hasMoreComments ?
                    <Button
                        className="view-button view-more-btn"
                        onClick={this.handleViewMore.bind(this)}
                    >
                        {this.state.isLoading ? "Loading..." : "View More"}
                    </Button>
                    : null}
     
            </div>
        );
    }
}

export default CommentList;